import {inject, Injectable, signal} from '@angular/core';
import {DataService} from './data.service';
import {ToastrService} from 'ngx-toastr';
import {RotaService} from '../http/rota/rota-service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

/**
 * This service handles finding and storing error messages of the selected store.
 */
@Injectable({
  providedIn: 'root'
})
export class RuleCheckerService {

  private dataService = inject(DataService);
  private rotaService = inject(RotaService);
  private toastr = inject(ToastrService);

  /** `True` if a request to get store errors is in progress. */
  loading = signal(false);
  /** A list of error messages for the selected store. */
  rotaErrors = signal<string[]>([]);

  /**
   * Finds and saves error messages for the selected store, if there are any.
   */
  check(): void {
    this.loading.set(true);
    this.rotaService.getStoreErrors(this.dataService.selectedStore.slug)
            .subscribe({
              next: (data) => {
                this.rotaErrors.set(data);
                this.loading.set(false);
              },
              error: (error) => {
                this.toastr.error(error.error.message);
                this.loading.set(false);
              }
            });
  }
}